module.exports = __webpack_public_path__ + "static/img/line-right.637c7c45.png";